module.exports = __webpack_public_path__ + "media/XP.7058f242.mp3";